package org.mkui.component

import org.mkui.canvas.MouseListener
import org.mkui.canvas.MouseMotionListener

interface CPInteractiveComponentProvider : CPComponentProvider, CPInteractiveComponent {
    override val component: CPInteractiveComponent

    override fun addMouseListener(l: MouseListener) {
        component.addMouseListener(l)
    }

    override fun addMouseMotionListener(l: MouseMotionListener) {
        component.addMouseMotionListener(l)
    }

    override fun removeMouseListener(l: MouseListener) {
        component.removeMouseListener(l)
    }

    override fun removeMouseMotionListener(l: MouseMotionListener) {
        component.removeMouseMotionListener(l)
    }
}